'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width : 100%;\n    height : 64px;\n    max-width : 325px;\n    max-height : 64px;\n    position : relative;\n    background-color : white;\n    border-bottom: solid 1px #f4f4f4;\n    border-radius: 6px;\n'], ['\n    width : 100%;\n    height : 64px;\n    max-width : 325px;\n    max-height : 64px;\n    position : relative;\n    background-color : white;\n    border-bottom: solid 1px #f4f4f4;\n    border-radius: 6px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CalendarHeading = _styledComponents2.default.div(_templateObject);
exports.default = CalendarHeading;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modern-datepicker/build/elements/CalendarHeading.js
// module id = 481
// module chunks = 0